export default "__VITE_ASSET__C$DlFoGa__"